/**
 * Rendez-Vous Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from '../../../constants/AppConfig';

// States
const state = {
    rdvs: [],
    rdv: {},
    rdvForm1: {},
    rdvForm2: {},
    rdvSent: null,
    intervale: {},
    rdvfromteleconsultations: {}
};

// Getters
const getters = {
    rdvs: state => {
        return state.rdvs
    },

    rdvfromteleconsultations: state => {
        return state.rdvfromteleconsultations
    },

    rdv: state => {
        return state.rdv
    },

    rdvForm1: state => {
        return state.rdvForm1
    },

    rdvForm2: state => {
        return state.rdvForm2
    },

    rdvSent: state => {
        return state.rdvSent
    },

    intervale: state => {
        return state.intervale
    }
};

// Actions
const actions = {
    getAppointments(context, payload) {
        function successCallback(response) {
            context.commit('getAppointmentsHandler', { rdvs: response.data.rdvs });
        }

        function errorCallback(error) {
            // Vue.notify({
            //     type: 'error',
            //     text: payload.errorMessages.error
            // });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.RDV.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getAppointment(context, payload) {
        function successCallback(response) {
            context.commit('getAppointmentHandler', { rdv: response.data.rdv });
        }

        function errorCallback(error) {
            // Vue.notify({
            //     type: 'error',
            //     text: payload.errorMessages.error
            // });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.RDV.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getRendezVousFromTeleconsultations(context, payload){
        function successCallback(response) {
            context.commit('getRendezVousHandler', { rdvfromteleconsultations: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/rendez_vous"}, localToken, successCallback, errorCallback, payload.errorMessages);
        // +payload.args.patient_id
    },

    setAppointmentForm1(context, payload) {
        // console.log("Set form 1 state...");
        context.commit('setAppointmentForm1Handler', { rdvForm1: payload.form });
    },

    setAppointmentForm2(context, payload) {
        // console.log("Set form 2 state...");
        context.commit('setAppointmentForm2Handler', { rdvForm2: payload.form });
    },

    getIntervals(context, payload) {
        function successCallback(response) {
            context.commit('getIntervalsHandler', { intervale: response.data.intervale });
        }

        function errorCallback(error) {
            // Vue.notify({
            //     type: 'error',
            //     text: payload.errorMessages.error
            // });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.RDV.GetIntervals, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    makeAppointment(context, payload) {
        function successCallback(response) {
            context.commit('makeAppointmentHandler', { status: true });
            state.rdvs[state.rdvs.length] = response.data.rdv;
            // context.commit('addAppointmentHandler', { rdv: response.data.rdv });

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            // if (payload.dashboard) {
            //     Vue.notify({
            //         type: 'success',
            //         text: payload.successMessage
            //     });
            //
            //     router.push({ name: 'appointments' });
            // }
        }

        function errorCallback(error) {
            context.commit('makeAppointmentHandler', { status: false });

            // Vue.notify({
            //     type: 'error',
            //     text: payload.errorMessages.error
            // });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.RDV.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateAppointment(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'appointments' });
        }

        function errorCallback(error) {
            // Vue.swal(
            //     payload.errorMessages.error,
            //     '',
            //     'error'
            // );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.RDV.Create.url + '/' + payload.rdv;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    cancelAppointment(context, payload) {
        function successCallback(response) {
            context.commit('cancelAppointmentHandler', { slug: payload.slug, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            // Vue.swal(
            //     payload.errorMessages.error,
            //     '',
            //     'error'
            // );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.RDV.Update, localToken, successCallback, errorCallback, payload.errorMessages);
        const url = AppConfig.apiUrl + apiModel.RDV.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    deleteAppointment(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            let i = state.rdvs.findIndex(rdv => rdv.slug === response.data.slug);

            if (~i) {
                state.rdvs.splice(i, 1);

                // router.push({ name: 'appointments' });

                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }
            // context.commit('deleteAppointmentHandler', { index: payload.rdv, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            /*Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });*/
            // Vue.swal(
            //     payload.errorMessages.error,
            //     '',
            //     'error'
            // );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.RDV.Create.url + '/' + payload.rdv;

        Vue.axios.delete(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);
    }
};

// Mutations
const mutations = {

    getRendezVousHandler(state, { rdvfromteleconsultations }){
        // Update bulletins state
        state.rdvfromteleconsultations = rdvfromteleconsultations;
    },

    getAppointmentsHandler(state, { rdvs }) {
        // Update rdvs state
        state.rdvs = rdvs;
    },

    getAppointmentHandler(state, { rdv }) {
        // Update rdv state
        state.rdv = rdv;
    },

    setAppointmentForm1Handler(state, { rdvForm1 }) {
        // Update rdvForm1 state
        state.rdvForm1 = rdvForm1
    },

    setAppointmentForm2Handler(state, { rdvForm2 }) {
        // Update rdvForm2 state
        state.rdvForm2 = rdvForm2
    },

    makeAppointmentHandler(state, { status }) {
        // Update rdvSent state
        state.rdvSent = status;
    },

    getIntervalsHandler(state, { intervale }) {
        // Update intervale state
        state.intervale = intervale;
    },

    addAppointmentHandler(state, {rdv}) {
        // state.rdvs.push(rdv);
    },

    deleteAppointmentHandler(state, { index, successMessage }) {
        let i = state.rdvs.findIndex(rdv => rdv.slug === index);

        if (~i) {
            state.rdvs.splice(i, 1);

            // router.push({ name: 'appointments' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    cancelAppointmentHandler(state, { slug, successMessage }) {
        let i = state.rdvs.findIndex(rdv => rdv.slug === slug);

        if (~i) {
            state.rdvs[i]['statut'] = 'Annulé';
            let rdvs = state.rdvs;
            state.rdvs = rdvs;
            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
